import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, normalizeClass as _normalizeClass, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("label", null, "Language:", -1)
const _hoisted_2 = ["value"]


export default /*#__PURE__*/_defineComponent({
  __name: 'LanguageSelector',
  setup(__props) {

const titles = {
    'en': 'English',
    'nl': 'Dutch'
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.$style.container)
  }, [
    _hoisted_1,
    _withDirectives(_createElementVNode("select", {
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.$i18n.locale) = $event)),
      class: _normalizeClass(_ctx.$style.select)
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$i18n.availableLocales, (locale) => {
        return (_openBlock(), _createElementBlock("option", {
          key: `locale-${locale}`,
          value: locale
        }, _toDisplayString(titles[locale] || locale), 9, _hoisted_2))
      }), 128))
    ], 2), [
      [_vModelSelect, _ctx.$i18n.locale]
    ])
  ], 2))
}
}

})